import cx from 'classnames';

import { IconThumbsDown_16 } from 'src/assets/icons/16x16/IconThumbsDown_16';
import { IconThumbsUp_16 } from 'src/assets/icons/16x16/IconThumbsUp_16';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
  // @ts-expect-error - no TypeScript definitions yet
} from 'src/components/CustomButton';
import { SAVED_DOCUMENT_RATING, type SavedDocumentTextRating } from 'src/data/savedDocument';
import { type CallbackN } from 'src/lib/types';

import styles from './RatingCard.module.scss';

interface RatingCardProps {
  className?: string;
  quote: string;
  // The ratings on this exact piece of text.
  ratings: SavedDocumentTextRating[];
  currentUserId?: string;
  onRemove: CallbackN<[SavedDocumentTextRating]>;
}

const ROWS = [
  { value: SAVED_DOCUMENT_RATING.thumbsUp, Icon: IconThumbsUp_16 },
  { value: SAVED_DOCUMENT_RATING.thumbsDown, Icon: IconThumbsDown_16 },
] as const;

export const RatingCard = ({
  className,
  quote,
  ratings,
  currentUserId,
  onRemove,
}: RatingCardProps) => {
  const mine = ratings.find((rating) => rating.author.id === currentUserId);

  return (
    <div className={cx(styles.root, className)}>
      <q className={styles.quote}>{quote}</q>

      {ROWS.map(({ value, Icon }) => {
        const names = ratings
          .filter((rating) => rating.value === value)
          .map((rating) => rating.author.name);
        if (names.length === 0) {
          return null;
        }
        return (
          <div
            key={value}
            className={styles.row}
          >
            <Icon
              className={cx(styles.icon, {
                [styles.negative]: value === SAVED_DOCUMENT_RATING.thumbsDown,
              })}
            />
            <span>{names.join(', ')}</span>
          </div>
        );
      })}

      {mine && (
        <CustomButton
          className={styles.remove}
          size={CUSTOM_BUTTON_SIZE.small}
          variant={CUSTOM_BUTTON_VARIANT.text}
          onClick={() => onRemove(mine)}
          data-testid="savedDocumentDeleteRatingButton"
        >
          Delete
        </CustomButton>
      )}
    </div>
  );
};
